import React from "react";
import { Modal } from "semantic-ui-react";

const ModalMultimediaImage = props => (
  <Modal
    trigger={
      <button className="btn p-0" type="button" style={styles.textDecoration}>
        {props.render}
      </button>
    }
    basic
    closeIcon
    size="large"
    style={styles.modalView}
  >
    <center>
      <Modal.Content style={styles.modalContent}>
        {props.renderImage}
      </Modal.Content>
    </center>
  </Modal>
);

const styles = {
  textDecoration: {
    textDecoration: "none",
    height: "auto",
    margin: "3%"
  },
  modalContent: {
    display: "flex",
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center"
  },
  modalView: {
    display: "flex",
    width: "95%"
  }
};

export default ModalMultimediaImage;
